import { Action } from "@ngrx/store";
import { IServerResponse } from "app/interface";

import {
  ADD_USER,
  ADD_USER_RESPONSE,
  ADMIN_LIST,
  DELETE_USER,
  DELETE_USER_RESPONSE,
  GET_ADMIN_LIST,
  GET_PARTNERS_LIST,
  GET_USER_LIST,
  GET_USER_LIST_BY_PARTNER_ID,
  PARTNERS_LIST,
  SEARCH_USER_BY_FIELD,
  SEARCH_USER_BY_ID,
  UPDATE_USER,
  UPDATE_USER_RESPONSE,
  USER_BY_FIELD_LIST,
  USER_BY_ID,
  USER_LIST,
  USER_LIST_BY_PARTNER_ID
} from "./actionTypes";

export class GetUserList implements Action {
  readonly type = GET_USER_LIST;
}

export class UserList implements Action {
  readonly type = USER_LIST;
  readonly payload = [];
  constructor(userList: Array<any>) {
    this.payload = userList;
  }
}

export class SearchUserById implements Action {
  readonly type = SEARCH_USER_BY_ID;
  readonly payload: string = null;
  constructor(id) {
    this.payload = id;
  }
}

export class UserById implements Action {
  readonly type = USER_BY_ID;
  readonly payload = null;
  constructor(data) {
    this.payload = data;
  }
}

export class SearchUserByField implements Action {
  readonly type = SEARCH_USER_BY_FIELD;
  readonly payload = null;
  constructor(data) {
    this.payload = data;
  }
}

export class UserByFieldList implements Action {
  readonly type = USER_BY_FIELD_LIST;
  readonly payload = null;
  constructor(data) {
    this.payload = data;
  }
}

export class AddUser implements Action {
  readonly type = ADD_USER;
  readonly payload = null;
  constructor(data) {
    this.payload = data;
  }
}

export class AddUserResponse implements Action {
  readonly type = ADD_USER_RESPONSE;
  readonly payload: IServerResponse = null;
  constructor(resp) {
    this.payload = resp;
  }
}

export class UpdateUser implements Action {
  readonly type = UPDATE_USER;
  readonly payload = null;
  constructor(data) {
    this.payload = data;
  }
}

export class UpdateUserResponse implements Action {
  readonly type = UPDATE_USER_RESPONSE;
  readonly payload: IServerResponse = null;
  constructor(resp) {
    this.payload = resp;
  }
}

export class DeleteUser implements Action {
  readonly type = DELETE_USER;
  readonly payload = null;
  constructor(id: string) {
    this.payload = id;
  }
}

export class DeleteUserResponse implements Action {
  readonly type = DELETE_USER_RESPONSE;
  readonly payload: IServerResponse = null;
  constructor(resp) {
    this.payload = resp;
  }
}

export class GetUserListByPartnerId implements Action {
  readonly type = GET_USER_LIST_BY_PARTNER_ID;
  readonly payload: string = null;
  constructor(id) {
    this.payload = id;
  }
}

export class UserListByPartnerId implements Action {
  readonly type = USER_LIST_BY_PARTNER_ID;
  readonly payload = null;
  constructor(data) {
    this.payload = data;
  }
}

export class GetPartnersList implements Action {
  readonly type = GET_PARTNERS_LIST;
}

export class PartnersList implements Action {
  readonly type = PARTNERS_LIST;
  readonly payload = [];
  constructor(partnersList: Array<any>) {
    this.payload = partnersList;
  }
}
export class GetAdminList implements Action {
  readonly type = GET_ADMIN_LIST;
  readonly payload = null;
  constructor(orgId: string) {
    this.payload = orgId;
  }
}

export class AdminList implements Action {
  readonly type = ADMIN_LIST;
  readonly payload = [];
  constructor(adminsList: Array<any>) {
    this.payload = adminsList;
  }
}

export type Actions =
  | GetUserList
  | UserList
  | SearchUserById
  | UserById
  | AddUser
  | AddUserResponse
  | UpdateUser
  | UpdateUserResponse
  | DeleteUser
  | DeleteUserResponse
  | SearchUserByField
  | UserByFieldList
  | GetUserListByPartnerId
  | UserListByPartnerId
  | GetPartnersList
  | PartnersList
  | GetAdminList
  | AdminList;
